module.exports = __webpack_public_path__ + "static/img/AU.c8fd8f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/countries/AU.svg
// module id = 928
// module chunks = 0